export default function swapElements<T>(array: Array<T>, index1: number, index2: number): Array<T> {
  array[index1] = array.splice(index2, 1, array[index1])[0];
  return array;
}